<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2022-03-23 10:23:20
-->

<template>
  <transition
    @beforeEnter="events.beforeEnter"
    @enter="events.enter"
    @afterEnter="events.afterEnter"
    @beforeLeave="events.beforeLeave"
    @leave="events.leave"
    @afterLeave="events.afterLeave"
  >
    <slot></slot>
  </transition>
</template>

<script>
class SideBarTransitionEventHandler {
  beforeEnter(el) {
    console.log("#-# SideBarTransitionEventHandler");
    if (!el.dataset) el.dataset = {};

    el.classList.add("side-bar__transition");
    el.dataset.oldPaddingLeft = el.style.paddingLeft;
    el.dataset.oldPaddingRight = el.style.paddingRight;

    el.style.width = "0";
    el.style.paddingLeft = 0;
    el.style.paddingRight = 0;
  }

  enter(el) {
    el.dataset.oldOverflow = el.style.overflow;
    if (el.scrollWidth !== 0) {
      el.style.width = el.scrollWidth + "px";
      el.style.paddingLeft = el.dataset.oldPaddingLeft;
      el.style.paddingRight = el.dataset.oldPaddingRight;
    } else {
      el.style.width = "";
      el.style.paddingLeft = el.dataset.oldPaddingLeft;
      el.style.paddingRight = el.dataset.oldPaddingRight;
    }

    el.style.overflow = "hidden";
  }

  afterEnter(el) {
    el.classList.remove("side-bar__transition");
    el.style.width = "";
    el.style.overflow = el.dataset.oldOverflow;
  }

  beforeLeave(el) {
    if (!el.dataset) el.dataset = {};
    el.dataset.oldPaddingLeft = el.style.paddingLeft;
    el.dataset.oldPaddingRight = el.style.paddingRight;
    el.dataset.oldOverflow = el.style.overflow;

    el.style.width = el.scrollWidth + "px";
    el.style.overflow = "hidden";
  }

  leave(el) {
    if (el.scrollWidth !== 0) {
      el.classList.add("side-bar__transition");
      el.style.width = 0;
      el.style.paddingLeft = 0;
      el.style.paddingRight = 0;
    }
  }

  afterLeave(el) {
    el.classList.remove("side-bar__transition");
    el.style.width = "";
    el.style.overflow = el.dataset.oldOverflow;
    el.style.paddingLeft = el.dataset.oldPaddingLeft;
    el.style.paddingRight = el.dataset.oldPaddingRight;
  }
}

export default {
  data() {
    return {
      events: new SideBarTransitionEventHandler(),
    };
  },
};
</script>

<style>
.side-bar__transition {
  transition: width 0.3s ease-in-out;
}
</style>